import { useState } from 'react'
import { Accordion, Alert, Button, Card, Form, Spinner } from 'react-bootstrap'
import { IUser } from '../../models/user';
import { useMutation } from 'react-query';
import { useAuth } from '../../context/auth';

type Props = {
    user: IUser
}

function PasswordSettings({user} : Props) {
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");

    const {updateUserPassword} = useAuth();
    const { mutateAsync: updateAccountFn, isLoading} = useMutation(
        updateUserPassword, // mutation function goes here
        {
            onSuccess: () => {},
            onError: (error) => {
                setError("Unexpected error. Please try again or contact admin.");
            },
        }
    );

    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if(!password || !newPassword || !confirmPassword) {
            setError("Please fill in all required fields");
            return
        }
        updateAccountFn({
            password,
            newPassword,
        })
    }

    return (
        <Accordion className="mb-4">
            <Accordion.Item eventKey="0" className="bg-dark border-secondary">
                <Accordion.Header className="bg-dark">
                    <Card.Title className="text-white">Change Password</Card.Title>
                </Accordion.Header>
                <Accordion.Body className="bg-dark">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="currentPassword" className="mb-3">
                            <Form.Label className="text-white">Current Password*</Form.Label>
                            <Form.Control 
                                type="password" 
                                value={password} 
                                placeholder='Enter current password' 
                                onChange={e => setPassword(e.target.value)}
                                className="bg-dark text-white border-secondary"
                                style={{
                                    backgroundColor: '#212529',
                                    borderColor: '#6c757d',
                                    color: '#ffffff'
                                }}
                                required/>
                        </Form.Group>
                        <Form.Group controlId="newPassword" className="mb-3">
                            <Form.Label className="text-white">New Password*</Form.Label>
                            <Form.Control 
                                type="password" 
                                value={newPassword} 
                                placeholder='Enter new password' 
                                onChange={e => setNewPassword(e.target.value)}
                                className="bg-dark text-white border-secondary"
                                style={{
                                    backgroundColor: '#212529',
                                    borderColor: '#6c757d',
                                    color: '#ffffff'
                                }}
                                required/>
                        </Form.Group>
                        <Form.Group controlId="confirmPassword" className="mb-3">
                            <Form.Label className="text-white">Confirm Password*</Form.Label>
                            <Form.Control 
                                type="password" 
                                value={confirmPassword} 
                                placeholder='Confirm new password' 
                                onChange={e => setConfirmPassword(e.target.value)}
                                className="bg-dark text-white border-secondary"
                                style={{
                                    backgroundColor: '#212529',
                                    borderColor: '#6c757d',
                                    color: '#ffffff'
                                }}
                                required/>
                        </Form.Group>
                        {error && (
                            <Alert variant="danger" className="mt-3 bg-danger bg-opacity-25 text-light border-danger">
                                {error}
                            </Alert>
                        )}
                        <Button type="submit" variant='primary'> 
                            {isLoading && <Spinner/>} Update Password
                        </Button>
                    </Form>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

export default PasswordSettings